/* eslint-disable no-use-before-define */
import React from 'react'
import {ajax, Status, getState, arrayFrom} from '../../twd/twd'

const state = getState('corporates.market-snapshot', {
    tab: 'MOST_ACTIVE_BUYS',
    rating: 'INVESTMENT_GRADE'
})

export default () => {
    const [tab, setTab_] = React.useState(state.value.tab || 'MOST_ACTIVE_BUYS')
    const setTab = React.useCallback((m) => {
        state.set({tab:m})
        setTab_(m)
    }, [])

    const [rating, setRating_] = React.useState(state.value.rating || 'INVESTMENT_GRADE')
    const setRating = React.useCallback((m) => {
        state.set({rating:m})
        setRating_(m)
    }, [])

    const [rows, setRows] = React.useState([])
    const [status, setStatus] = React.useState(Status.LOADING)

    React.useEffect(() => {

        setRows([])
        ;(async () => {
            try {
                setStatus(Status.LOADING)
                let url = '/esb/retailservice/marketSnapshotService/getMarketSnapshotByType'
                let mktType = marketSnapshotsTypes[rating + '-' + tab]
                let {data} = await ajax({
                    url,
                    method: 'POST',
                    params: {
                        marketSnapshotsType: mktType
                    }
                })

                let a = await data
                setRows(arrayFrom(a))

                setStatus(Status.LOADED)
            } catch(e) {
                setStatus(Status.FAILED_TO_LOAD)
            }
        })()

    }, [tab, rating])

    return { tab, setTab, rating, setRating, rows, status }
}

const marketSnapshotsTypes = {
    'INVESTMENT_GRADE-MOST_ACTIVE_BUYS': 'IG_MOST_ACTIVE_BUYS',
    'INVESTMENT_GRADE-HIGHEST_RATIO': 'IG_HIGH_BUY_SELL_RATIO',
    'INVESTMENT_GRADE-LOWEST_RATIO': 'IG_LOW_BUY_SELL_RATIO',
    'HIGH_YIELD-MOST_ACTIVE_BUYS': 'HY_MOST_ACTIVE_BUYS',
    'HIGH_YIELD-HIGHEST_RATIO':'HY_HIGH_BUY_SELL_RATIO',
    'HIGH_YIELD-LOWEST_RATIO': 'HY_LOW_BUY_SELL_RATIO'
}
        // IG_MOST_ACTIVE,
        // HY_MOST_ACTIVE,
        // IG_MOST_ACTIVE_BUYS,
        // HY_MOST_ACTIVE_BUYS,
        // IG_HIGH_BUY_SELL_RATIO,
        // HY_HIGH_BUY_SELL_RATIO,
        // IG_LOW_BUY_SELL_RATIO,
        // HY_LOW_BUY_SELL_RATIO